import "./styles.scss";
import { useState, useEffect, useRef } from "react";
import { Select, MenuItem, Pagination, CircularProgress  } from "@mui/material";
import {
  clearAllTableFilters,
  clearSelectedRowsData,
  onChangeFilters,
  onChangeSortby,
  onPageChange,
  onSelectionChange, 
} from "../../../redux/features/table/tableSlice"; 
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as SelectAllIcon } from "../../../assets/images/slotplanning/sellect_all.svg";
import { ReactComponent as CloseIcon } from "../../../assets/images/slotplanning/close_icon.svg";
import { Badge } from 'react-bootstrap';
const Table = ({
  loading = false,
  columns = [],
  rows = [],
  rowKey = "id",
  totalRow = null,
  checkboxSelection = false,
  totalRecords = 0,
  disableSearch = false,
  disableSortby = false,
  handleDoubleClick = () => {},
  disablePagination = false,
  onClickRow = () => null,
  selectedRowId = null,
  tableRef = null,
  bulkActions = [],
  onIPPChange,
  onCPChange = () => {},
  pref = true
}) => {
  const limitOptions = [25, 50, 75, 100];

  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);
  const [sortType, setSortType] = useState(null);
  const [sortByField, setSortByField] = useState(null);
  const [filters, setFilters] = useState({});

  const isFirstFiltersRun = useRef(true);
  const prevTab = useRef(null);

  const dispatch = useDispatch();
  const { clearFilters, tab, clearSelectedRows } = useSelector(
    (state) => state.table
  );

  const totalPages = Math.ceil(totalRecords / itemsPerPage);
  const startIndex = currentPage * itemsPerPage - itemsPerPage + 1;
  const endIndex = currentPage * itemsPerPage;

 

  useEffect(() => {
    dispatch(
      onPageChange({
        pagenum: currentPage - 1,
        pagesize: itemsPerPage,
        recordstartindex: startIndex - 1,
        recordendindex: endIndex,
      })
    );
  }, [currentPage, itemsPerPage]);

  useEffect(() => {
    if (!sortByField) {
      dispatch(onChangeSortby({}));
    } else {
      dispatch(
        onChangeSortby({
          sortorder: sortType,
          sortdatafield: sortByField,
        })
      );
    }
  }, [sortByField, sortType]);

  useEffect(() => {
    dispatch(onSelectionChange(selectedRows));
  }, [selectedRows]);


  useEffect(() => {
  if (isFirstFiltersRun.current) {
    isFirstFiltersRun.current = false;
    return;
  }
  if (Object.keys(filters).length === 0) return;

  const timeout = setTimeout(() => {
    const cleaned = Object.fromEntries(
      Object.entries(filters).filter(([_, v]) => v !== "")
    );
    setCurrentPage(1);
    dispatch(onChangeFilters(cleaned));
  }, 1000);
  return () => clearTimeout(timeout);
}, [filters]);

  useEffect(() => {
    if (clearFilters) {
      setFilters({});
      dispatch(clearAllTableFilters(false));
    }
  }, [clearFilters]);

  useEffect(() => {
    if (clearSelectedRows) {
      setSelectedRows([]);
      dispatch(clearSelectedRowsData(false));
    }
  }, [clearSelectedRows]);

  useEffect(() => {
    const previous = prevTab.current;
    prevTab.current = tab;

    // Skip if there was no real previous tab (null or empty)
    const wasInitialized = !!previous?.value && !!previous?.key;
    if (!wasInitialized) return;

    setCurrentPage(1);
    setSortByField(null);
    setSortType(null);
    setSelectedRows([]);
    setFilters({});
    dispatch(onChangeFilters({}));
  }, [tab]);

 

  const handleRowsSelection = (row) => {
    const key = row[rowKey];

    setSelectedRows((prev) => {
      const exists = prev.some((r) => r[rowKey] === key);

      return exists
        ? prev.filter((r) => r[rowKey] !== key)
        : [...prev, row];
    });
  };

    const handleSelectAll = (e) => {
        setSelectedRows(e.target.checked ? rows : []);
    };

    const handleSortBy = (field) => {
    if (sortByField !== field) {
        setSortByField(field);
        setSortType("asc");
    } else if (sortType === "asc") {
        setSortType("desc");
    } else {
        setSortType(null);
        setSortByField(null);
    }
    };

    const handleSearch = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const RenderSortByIcon = ({ field }) => {
    const isActive = sortByField === field;

    return (
        <span
        className="sort-icon"
        style={{
            cursor: "pointer",
            marginLeft: 5,
            color: isActive ? "#566D80" : "#AAAAAA",
            fontSize: 12,
        }}
        onClick={() => handleSortBy(field)}
        >
        {sortType === "desc" && isActive ? "▼" : "▲"}
        </span>
    );
    };

  return (
    <div className="table-container" ref={tableRef}>
      <div className="table">
        <table>
          <thead>
            <tr>
              {rows.length !== 0 && checkboxSelection && (
                <th className="single_check">
                  <input
                    className="select-all-checkbox"
                    type="checkbox"
                    checked={rows.length === selectedRows.length}
                    onChange={handleSelectAll}
                  />
                </th>
              )}

              {columns.map((column, index) => (
                <th key={index} className={column?.cls}>
                  <div className="col-header-container">
                    {column?.isEdit && (
                      <span style={{ fontSize: 14 }}>Edit</span>
                    )}
                    {column?.label}
                    {rows.length !== 0 &&
                      !disableSortby &&
                      column?.enableSearch !== false && (
                        <RenderSortByIcon field={column.field} />
                      )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
        <tbody>  
            {totalRow && Object.keys(totalRow).length > 0 && (
              <tr className="total-row">
                {checkboxSelection && <td></td>}
                {columns.map((col, i) => (
                  <td key={i}>
                    <p>
                      {typeof totalRow[col.field] === "string" ||
                      typeof totalRow[col.field] === "number"
                        ? totalRow[col.field]
                        : ""}
                    </p>
                  </td>
                ))}
              </tr>
            )}

            {loading ? (
              <tr className="no-data-row">
                <td colSpan={columns.length + 1}>
                  <div className="spinner-container">
                    <div className="custom-loader" />
                  </div>
                </td>
              </tr>
            ) : rows.length ? (
              rows.map((row, index) => (
                <tr
                  key={index}
                  onDoubleClick={() => handleDoubleClick(row)}
                  // onClick={() => onClickRow(row[rowKey])}
                  onClick={() => onClickRow(row)}
                  className={
                    selectedRowId === row[rowKey] ||
                    selectedRows.some((r) => r[rowKey] === row[rowKey])
                      ? "selected-row"
                      : ""
                  }
                >
                  {checkboxSelection && (
                    <td onDoubleClick={(e) => e.stopPropagation()}>
                      <input
                        type="checkbox"
                        checked={selectedRows.some((r) => r[rowKey] === row[rowKey])}
                        onChange={() => handleRowsSelection(row)}
                      />
                    </td>
                  )}
                  {columns.map((col, i) => (
                    <td key={i}>
                      {col.renderCell
                        ? col.renderCell(row)
                        : typeof row[col.field] === "string" || typeof row[col.field] === "number"
                        ? row[col.field]
                        : ""}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr className="no-data-row">
                <td colSpan={columns.length + 1}>
                  <div className="no-data">
                    <h2>No Data Available!</h2>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {!disablePagination && (
        <div className="table-pagination-container">
          <Pagination
            count={totalPages}
            shape="rounded"
            size="small"
            page={currentPage}
            onChange={(e, val) => {setCurrentPage(val); onCPChange(val)}}
          />

          <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
            <p style={{ fontSize: 14, fontWeight: 500, marginTop: 12 }}>
              Results: {startIndex} -{" "}
              {endIndex > totalRecords ? totalRecords : endIndex} of{" "}
              {totalRecords}
            </p>

            <Select
              value={itemsPerPage}
              onChange={(e) => {
                setCurrentPage(1);
                setItemsPerPage(e.target.value);
                onIPPChange?.(e.target.value)
              }}
            >
              {limitOptions.map((item, i) => (
                <MenuItem key={i} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </div>
        </div>
      )}

      {selectedRows.length > 0 && (
        <div className="bulk-action-bar">
          <div className="bulk-left">
            <span><Badge>{selectedRows.length}</Badge> Selected</span>
            <button onClick={() => setSelectedRows(rows)}>
              <SelectAllIcon />
              Select All
            </button>
            {bulkActions.map((action, i) => {
              const Icon = action.icon;

              return (
                <button key={i} onClick={() => action.action(selectedRows)}>
                  {Icon && <Icon className="action-icon" />}
                  {action.label}
                </button>
              );
            })}
          </div>
          <button className="bulk-close" onClick={() => setSelectedRows([])}>
            <CloseIcon />
          </button>
        </div>
      )}
    </div>
  );
}

export default Table;
